// extracted by mini-css-extract-plugin
export default {"wrapper":"addGatewayModal_wrapper__RYWYu","tips":"addGatewayModal_tips__Vp2rI","blue":"addGatewayModal_blue__Cr6RA","info":"addGatewayModal_info__obkQ0"};